<template>
  <div id="system-journal-setting-country-setting-edit">
    <ipub-model title="Edit Article Type"
                width="600px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p2 mar-b-10">
        <span class="fw-bd">Article Type
          <font class="key-color">*</font>
        </span>
        <span class="mar-l-20">{{params.atype && params.atype.name}}</span>
      </div>
      <div class="mar-b-10">
        <div class="ipub-p2 fw-bd mar-b-10">
          Publishing Suggestions <font class="key-color">*</font>
        </div>
        <ipub-radio-group v-model="params.publishSuggestion"
                          _label="name"
                          :options="[{name:'Encourage',value:'ENCOURAGE'},{name:'Support',value:'SUPPORT'},{name:'Not Recommended',value:'NOT_RECOMMENDED'}]" />
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { settingJournalAtype } from '@/api/setting'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {
        linked: true,
      },
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      publisherId: 'getPublisherId'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      } else {
        this.params = JSON.parse(JSON.stringify(this.inputData))
      }
    }
  },
  methods: {
    async confirm () {
      const flag = this.params.publishSuggestion
      if (flag) {
        await settingJournalAtype.edit(this.params.id, this.params)
        this.$message.success({ title: 'Success', content: 'This Article Type has been Saved!' })
        this.$emit('confirm')
      } else {
        this.$message.error({ title: 'Error', content: 'Publishing Suggestions is empty!' })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
#system-database-add {
  .upload-content {
    height: 77px;
    width: 253px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .file-content {
    width: 84%;
    height: 40px;
    margin-right: 15px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d9dfe2;
    line-height: 40px;
    padding: 0 12px;
  }
}
</style>
